import * as React from "react";
import Title from "../../app/components/Title";
import PageSizeSelection from "./PageSizeSelection";
import {
  Box,
  Button,
  Grid,
  Link,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from "@mui/material";
import SubTitle from "../../app/components/SubTitle";

interface Props {
  menuname: string;
  description: string;
  count: string;
  lastupdate: string;
}

export default function DatabaseInfo(props: Props) {
  return (
    <>
      <TableContainer>
        <Table>
          <TableBody>
            <TableRow>
              <TableCell>
                <SubTitle color="black">Database</SubTitle>
              </TableCell>
              <TableCell>{props.menuname}</TableCell>
            </TableRow>

            <TableRow>
              <TableCell>
                <SubTitle color="black">Description</SubTitle>
              </TableCell>
              <TableCell>{props.description}</TableCell>
            </TableRow>

            <TableRow>
              <TableCell>
                <SubTitle color="black">Count</SubTitle>
              </TableCell>
              <TableCell>{props.count}</TableCell>
            </TableRow>

            <TableRow>
              <TableCell>
                <SubTitle color="black">Last update</SubTitle>
              </TableCell>
              <TableCell>{props.lastupdate}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>

      {/* <TableRow>
              <TableCell>
                <span style={{ fontStyle: "italic" }}>
                  *Orders over $100 qualify for free delivery
                </span>
              </TableCell>
            </TableRow> */}
    </>
  );
}
